import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';

export class InfracaoTransporteSearch {

    cdInfracao: number;
    nrInfracao: string;
    tpConcessao: number;
    dsInfracao: string;
    limit: number;
    page: number;
    
    constructor(data?: {
        cdInfracao?: number,
        nrInfracao?: string,
        tpConcessao?: number,
        dsInfracao?: string,
        limit?: number,
        page?: number
    }) {
        this.cdInfracao = data && data.cdInfracao;
        this.nrInfracao = data && data.nrInfracao;
        this.tpConcessao = data && data.tpConcessao;
        this.dsInfracao = data && data.dsInfracao;
        this.limit = data && data.limit;
        this.page = data && data.page;
    }

    getFilters(): IFilter {
        let filtros: IFilter = new HttpFilter([]);
        
        if (this.cdInfracao) {
            filtros.addFilter(new Equal('cdInfracao', this.cdInfracao));
        }

        if (this.nrInfracao) {
            filtros.addFilter(new Equal('nrInfracao', this.nrInfracao));
        }
        
        if (this.tpConcessao != null && this.tpConcessao >= 0) {
            filtros.addFilter(new Equal('tpConcessao', this.tpConcessao));
        }

        if (this.dsInfracao) {
            filtros.addFilter(new Equal('dsInfracao', this.dsInfracao));
        }
        
        if (this.page > -1) {
            filtros.addFilter(new Equal('page', this.page));
        }

        if (this.limit > 0) {
            filtros.addFilter(new Equal('limit', this.limit));
        }
        
        return filtros;
    }
}